import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { EFormColumn } from '../../../../shared-components/e-forms/e-form-column.model';
import { EFormService } from '../../../../shared-components/e-forms/e-form.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDrag } from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { EFormControl } from '../../../../shared-components/e-forms/e-form-control.model';
import * as _ from 'lodash';
import { EFormRow } from '../../../../shared-components/e-forms/e-form-row.model';
import { MatDialog } from '@angular/material/dialog';
import { GeneralConfirmationComponent } from '../../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { EFormDesignerService } from '../e-form-designer.service';
import { EFormRrowColumnLocationComponent } from '../e-form-row-column-location/e-form-row-column-location';
import { EFormConfiguration } from '../../e-form-config.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'e-form-column',
  templateUrl: './e-form-column.component.html',
  styleUrls: ['./e-form-column.component.css']
})
export class EFormColumnComponent implements OnInit, OnDestroy {

  @Input() column: EFormColumn;
  @Input() hideEditHeader: boolean;
  @Input() config: EFormConfiguration;
  @Output() columnClickEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  subscriptions: Subscription[] = [];
  isSelected = false;
  isDragging = false;
  connectedDropLists: string[] = [];
  @ViewChildren('controlList', { read: ElementRef }) set sort(lists: QueryList<ElementRef>) {
    lists.forEach(list => {
      this.eFormDesignerService.connectedDropListAdd(list.nativeElement.id);
    });
  }

  constructor(
    private eFormService: EFormService,
    private eFormDesignerService: EFormDesignerService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.setSelectedStatus();
    this.subscriptions.push(this.eFormDesignerService.observableselectedElementChangedStream$.subscribe(o => {
      this.setSelectedStatus();
    }));
    this.subscriptions.push(this.eFormDesignerService.observableDragStartStream$.subscribe(() => {
      this.isDragging = true;
    }));
    this.subscriptions.push(this.eFormDesignerService.observableDragEndStream$.subscribe(() => {
      this.isDragging = false;
    }));
    this.connectedDropLists = this.eFormDesignerService.connectedDropLists;
    this.subscriptions.push(this.eFormDesignerService.observableConnectedDropListsStream$.subscribe((list) => {
      this.connectedDropLists = list;
    }));
  }

  setSelectedStatus() {
    if (this.eFormDesignerService.selectedElementType == 'column' && this.eFormDesignerService.selectedColumn == this.column) {
      setTimeout(() => {
        this.isSelected = true;
      }, 0);
    }
    else {
      setTimeout(() => {
        this.isSelected = false;
      }, 0);
    }
  }

  columnClick(event) {
    event.preventDefault();
    this.columnClickEvent.emit(true);
    this.eFormDesignerService.focusOnColumn(this.column);
    event.stopPropagation();
    this.eFormDesignerService.openPropertiesTab();
  }

  controlDropped(event: CdkDragDrop<EFormControl[]>) {
    if (event.container.id === event.previousContainer.id) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
    else if (event.previousContainer.id.indexOf('controlPalette') >= 0) {
      const newControl = <EFormControl>_.cloneDeep(event.item.data);
      this.eFormDesignerService.assignControlsNewID([newControl]);
      // newControl.Id = ++this.eFormService.selectedFormData.LastUsedControlId;
      // this.column.Controls.push(newControl);
      this.column.Controls.splice(event.currentIndex, 0, newControl);
    }
    else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    if (this.column.Rows && this.column.Rows.length > 0) {
      this.column.Controls.forEach(control => {
        const newRow = new EFormRow();
        newRow.Controls = [];
        newRow.Controls.push(control);
        this.column.Rows.push(newRow);
      });
      this.column.Controls = [];
    }
    this.eFormDesignerService.getAllFormControls();
    this.eFormDesignerService.focusOnControl(event.container.data[event.currentIndex]);
  }

  ngOnDestroy() { }

  dragStart() {
    this.eFormDesignerService.dragStart();
  }

  dragEnd() {
    this.eFormDesignerService.dragEnd();
  }

  rowDropped(event: CdkDragDrop<EFormRow[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(this.column.Rows, event.previousIndex, event.currentIndex);
    }
  }

  rowPredicate(item: CdkDrag<EFormRow>) {
    if (this.column && this.column.Rows && this.column.Rows.find(o => o == item.data)) {
      return true;
    }
    else {
      return false;
    }
  }

  deleteClick() {
    if (this.eFormDesignerService.columnHasNonRemovableControls(this.column)) {
      const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
        disableClose: true,
      });
      deleteConfirmDialog.componentInstance.headerLabel = 'Delete Column';
      deleteConfirmDialog.componentInstance.disableConfirmation = true;
      deleteConfirmDialog.componentInstance.confirmMessage = 'This column contains controls that cannot be removed.';
    }
    else if (!this.eFormDesignerService.canDeleteColumn(this.column)) {
      const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
        disableClose: true,
      });
      deleteConfirmDialog.componentInstance.headerLabel = 'Delete Column';
      deleteConfirmDialog.componentInstance.disableConfirmation = true;
      deleteConfirmDialog.componentInstance.confirmMessage = 'You cannot remove the last column on a page.';
    }
    else {
      const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
        disableClose: true,
      });
      deleteConfirmDialog.componentInstance.headerLabel = 'Delete Column';
      deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete this column and all its content?';
      deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
        if (deleteObject) {
          this.eFormDesignerService.deleteSelectedElement();
        }
      });
    }
  }

  copyClick() {
    this.eFormDesignerService.locationToAdd = '';
    const copyConfirmDialog = this.dialog.open(EFormRrowColumnLocationComponent, {
      disableClose: true,
    });
    copyConfirmDialog.componentInstance.headerLabel = 'Copy Column';
    copyConfirmDialog.componentInstance.cotrolType = 'column';
    this.subscriptions.push(copyConfirmDialog.afterClosed().subscribe(result => {
      if (result) {
        this.eFormDesignerService.locationToAdd = result;
        this.eFormDesignerService.addColumn(this.config);
      }
      else {
        this.eFormDesignerService.locationToAdd = '';
      }
    }));
  }

  getControlId(index: number, control: EFormControl) {
    return control.Id;
  }

  getRowId(index: number, row: EFormRow) {
    return index;
  }
}
